<script setup>
  import { onMounted, useTemplateRef } from 'vue'
  import { useWishlistStore } from '@/stores/wishlist'
  import { storeToRefs } from 'pinia'

  const wishlistMenuButton = useTemplateRef('wishlistMenuButton')
  const store = useWishlistStore()
  const { hasWishlistAccepted } = storeToRefs(store)

  onMounted(() => {
    store.checkWishlistAccepted()

    const buttons = document.querySelectorAll('.add-to-wishlist')

    buttons.forEach((button) => {
      button.addEventListener('click', toggleWishlistAnimation)
    })
  })

  const toggleWishlistAnimation = () => {
    if (!wishlistMenuButton.value) return
    wishlistMenuButton.value.classList.add('animate')
    setTimeout(() => {
      wishlistMenuButton.value.classList.remove('animate')
    }, 1000)
  }
</script>

<template>
  <a
    href="/merkliste"
    v-if="hasWishlistAccepted"
    ref="wishlistMenuButton"
    aria-label="Merkliste öffnen"
    class="wishlist-menu-button transition-all duration-500 border-l border-white/30 px-6 h-full min-w-14 lg:min-w-20 min-h-12 flex w-auto flex-col relative items-center justify-center"
  >
    <AppIcon
      name="Heart"
    />
  </a>
</template>

<style lang="scss">
  .header-inner.bg-white {
    .wishlist-menu-button svg path {
      @apply transition-all duration-500 fill-black !important;

    }
    .user-login-toggle svg path {
      @apply transition-all duration-500 fill-black !important;

    }
    .wishlist-menu-button {
      @apply border-border;
      &:hover {
        svg path {
          @apply fill-primary !important;
        }
      }
    }
  }
  .wishlist-menu-button {
    &:hover {
      @apply scale-110;
      svg path {
        @apply fill-primary !important;
      }
    }
    &.animate {
      @apply scale-125;
      svg path {
        @apply fill-primary !important;
      }
    }
  }
</style>
